// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gwcZj","label":"styles_label__2ENdq"};